import { Image }                         from '../Image/Image';
import { FileReference, IFileReference } from '../FileReference/FileReference';
import { createUniqKey, sortImages }     from 'Utils';

export interface IOrganizer {
  id: string,
  name: string,
  email: string,
  activeEventsCount: number|null,
  totalEventsCount: number|null,
  slug: string | null,
  shareLink: string | null,
  phone: string | null;
  website: string | null;
  street: string | null;
  zip: string | null;
  city: string | null;
  contactEmail: string,
  description: string,
  invoiceName: string,
  invoiceStreet: string,
  invoicePostcode: string,
  invoiceCity: string,
  invoiceCountry: string,
  stripeId: string,
  ticketPercentageFeeOverride: string,
  images: Image[] | IFileReference[],
  startAt: Date|null,
  endAt: Date|null,
}

export class Organizer {
    public _key: string;
    public id: string;
    public name: string;
    public email: string;
    public contactEmail: string;
    public description: string;
    public invoiceName: string;
    public invoiceStreet: string;
    public invoicePostcode: string;
    public invoiceCity: string;
    public invoiceCountry: string;
    public stripeId: string;
    public ticketPercentageFeeOverride: string;
    public images: Image[];
    public startAt: Date|null;
    public endAt: Date|null;
    public _userRole?: string | null;

    public activeEventsCount: number|null;
    public totalEventsCount: number|null;
    public slug: string | null;
    public shareLink: string | null;
    public phone: string | null;
    public website: string | null;
    public street: string | null;
    public zip: string | null;
    public city: string | null;

    constructor(data: IOrganizer) {
      this._key = createUniqKey();
      this.id = data.id;
      this.name = data.name;
      this.email = data.email;
      this.contactEmail = data.contactEmail;
      this.activeEventsCount = data.activeEventsCount;
      this.totalEventsCount = data.totalEventsCount;
      this.slug = data.slug;
      this.shareLink = data.shareLink;
      this.phone = data.phone;
      this.website = data.website;
      this.street = data.street;
      this.zip = data.zip;
      this.city = data.city;
      this.description = data.description;
      this.invoiceName = data.invoiceName;
      this.invoiceStreet = data.invoiceStreet;
      this.invoicePostcode = data.invoicePostcode;
      this.invoiceCity = data.invoiceCity;
      this.invoiceCountry = data.invoiceCountry;
      this.stripeId = data.stripeId;
      this.ticketPercentageFeeOverride = data.ticketPercentageFeeOverride;
      this.images = sortImages(data.images ? data.images.map((image) => new FileReference(image as IFileReference)) : []);
      this.startAt = data.startAt ? new Date(data.startAt) : null;
      this.endAt = data.endAt ? new Date(data.endAt) : null;
      this._userRole = null;
    }
}

export const createNewOrganizer = (data: Partial<IOrganizer> = {}): Organizer => new Organizer({
  id: data.id || 'new',
  name: data.name || '',
  email: data.email || '',
  contactEmail: data.contactEmail || '',
  description: data.description || '',
  invoiceName: data.invoiceName || '',
  activeEventsCount: data.activeEventsCount || 0,
  totalEventsCount: data.totalEventsCount || 0,
  slug: data.slug || '',
  shareLink: data.shareLink || '',
  phone: data.phone || '',
  website: data.website || '',
  street: data.street || '',
  zip: data.zip || '',
  city: data.city || '',
  invoiceStreet: data.invoiceStreet || '',
  invoicePostcode: data.invoicePostcode || '',
  invoiceCity: data.invoiceCity || '',
  invoiceCountry: data.invoiceCountry || '',
  stripeId: data.stripeId || '',
  ticketPercentageFeeOverride: data.ticketPercentageFeeOverride || '',
  images: data.images ? data.images : [],
  startAt: data.startAt || null,
  endAt: data.endAt || null,
});
